import styled from "styled-components";
import { ChevronRightCircle } from "@styled-icons/boxicons-solid";
import { fonts } from "styles";

export const Container = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow-x: auto;
  --webkit-overflow-scrolling: touch;
  overscroll-behavior: none;
  position: relative;

  ::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: 1010px) {
    flex-direction: column;
    width: 100%;
    height: auto;
    min-height: 100vh;
    overflow-x: hidden;
  }
`;

export const SectionWrapper = styled.div`
  width: max-content;
  flex-shrink: 0;
  flex-grow: 0;
  height: 100vh;
  display: flex;
  /* pointer-events: none; */

  &.home {
    min-width: 100vw;
    width: 100%;
  }

  &.left {
    margin-left: -222px;
  }

  @media screen and (max-width: 1010px) {
    width: 100%;
    height: auto;
    pointer-events: all;
    flex-shrink: unset;
    flex-grow: unset;

    &.left {
      margin-left: 0;
    }
  }
`;

export const ScrollInfo = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 22px;
  font-family: ${fonts.BentonSansMedium};
  letter-spacing: 2px;
  color: black;
  text-transform: uppercase;
  position: absolute;
  bottom: 32px;
  right: 32px;
  pointer-events: none;
  z-index: 99;

  @media screen and (max-width: 1010px) {
    display: none;
  }
`;

export const IconChevron = styled(ChevronRightCircle).attrs({ size: 24 })`
  color: black;
  margin-left: 8px;
`;
